import type { ComponentProps } from 'react'
import type { Badge } from '@/components/catalyst/badge'

type BadgeColor = ComponentProps<typeof Badge>['color']

const STATE_COLORS: Record<string, BadgeColor> = {
  new_deal: 'sky',
  deals_to_review: 'indigo',
  deals_to_place: 'violet',
  deals_requiring_deposit: 'amber',
  unconfirmed_vendor_po: 'orange',
  vendor_po_issues: 'red',
  confirmed_orders: 'emerald',
  vendor_payments: 'lime',
  needs_routing: 'yellow',
  shipped_from_brand: 'cyan',
  in_warehouse: 'blue',
  scanned: 'teal',
  partially_scanned: 'teal',
  ready_to_ship: 'green',
  released: 'purple',
  shipped_to_client: 'fuchsia',
  closed_lost: 'zinc',
  consignment: 'pink',
  samples: 'rose',
  stock: 'stone' as BadgeColor,
  clubs: 'indigo',
  sub_id: 'zinc',
  parent_with_closed_gmv: 'zinc',
}

export function useOrderStatus(state: string) {
  const color = STATE_COLORS[state] || 'zinc'
  const label = state.replace(/_/g, ' ').toUpperCase()
  return { color, label }
}

export function getOrderStatusColor(state: string): BadgeColor {
  return STATE_COLORS[state] || 'zinc'
}

export function getOrderStatusLabel(state: string): string {
  return state.replace(/_/g, ' ').toUpperCase()
}
